export const DASHBOARD_ASSIGNED_PROCESSES_OVERVIEW_MODEL = "Assigned_Processes_O";
export const DASHBOARD_RECENT_CHANGES_OVERVIEW_MODEL = "Recent_Changes_O";
export const DASHBOARD_UPCOMING_DEADLINES_OVERVIEW_MODEL = "Upcoming_Deadlines_O";
export const DASHBOARD_DOCUMENT_MODEL = "Generic_Prozess_WF";
